<template>
	<iframe
		class="widget"
		:src="endpoint"
		frameborder="0"
		style="border:0"
		referrerpolicy="no-referrer-when-downgrade"
	/>
</template>

<script>

export default {
    name: 'WidgetView',
	props: {
		widget: Object
	},
	data () {
		return {
			endpoint: null
		}
	},
	mounted () {

		const path = 'https://www.google.com/maps/embed/v1/'
		const prefix = this.widget.settings.showMarker ? 'place' : 'view'
		const key = `?key=${this.widget.settings.apiKey}`
		const center = `&center=${this.widget.settings.latitude},${this.widget.settings.longitude}`
		const zoom = `&zoom=${this.widget.settings.zoom}`
		const maptype = `&maptype=${this.widget.settings.type}`
		const q = this.widget.settings.showMarker ? '&q=Resavska+33+Beograd' : ''

		this.endpoint = `${path}${prefix}${key}${center}${zoom}${maptype}${q}`

	}
}
</script>

<style lang="scss" scoped>
.widget {
	height: 100%;
	width: 100%;
}
</style>
